import { Component } from 'react';
import { connect } from 'react-redux';
import Router from 'next/router';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

const GroupsCreate = connect((state) => state)(
  class extends Component {
    handleModalVisible = () => {
      this.titleInputContainer.querySelector('input').focus();
    };

    submit = async (values) => {
      const { dispatch, messages } = this.props;

      const response = await api.post('/admin/groups', values);
      dispatch(
        actions.addNotice({
          text: messages.groupsCreateGroupSuccess,
          type: 'success'
        })
      );
      Router.push('/groups/[groupId]', `/groups/${response.data.group.id}`);
    };

    validateTitle = async (value) => {
      const { messages } = this.props;

      if (!value) return messages.commonTitleEmpty;

      try {
        await api.head(`/admin/groups?title=${value}`);
        return messages.commonTitleInUse;
      } catch (err) {
        return undefined;
      }
    };

    render() {
      const { messages } = this.props;
      return (
        <ModalButtonWithForm
          buttonCategory="success"
          buttonIcon="plus"
          buttonText={messages.groupsCreateGroup}
          modalActionText={messages.commonCreate}
          modalTitle={messages.groupsCreateGroup}
          onModalVisible={this.handleModalVisible}
          onSubmit={this.submit}
          pristineIsValid={false}
        >
          {(formState) => (
            <FormGroup htmlFor="title" label={messages.groupsGroupTitle}>
              <Text
                customValidateAsync={this.validateTitle}
                field="title"
                id="title"
                inputContainerRef={(el) => (this.titleInputContainer = el)}
              />
            </FormGroup>
          )}
        </ModalButtonWithForm>
      );
    }
  }
);

export default GroupsCreate;
